import { LegacyPortalPurchaseHistoryProductType } from "@spwn-portal/grpc";
import { toPurchaseHistoryOrderPath } from "features/purchaseHistory/purchaseHistoryOrderPath";
import {
  toPaymentStatus,
  toPayType,
} from "features/purchaseHistory/purchaseHistoryOrderValues";

import { getEventImageThumbnail } from "../getImagePath";

import type { ConvertedSettlement } from "../convertSettlementToCardProps/props";
import type {
  LegacyPortalPurchaseHistoryOrder,
  LegacyPortalPurchaseHistoryOrderItem,
} from "@spwn-portal/grpc";

/** チケットはイベント画像、それ以外は商品のサムネイルを使う。Firestore直読み側と同じ規則 */
const getImagePath = (
  firstItem: LegacyPortalPurchaseHistoryOrderItem | undefined
): string => {
  if (firstItem === undefined) return "";

  if (
    firstItem.productType === LegacyPortalPurchaseHistoryProductType.TICKET &&
    firstItem.event !== undefined
  ) {
    const { bannerImagePath, defaultImage } = firstItem.event;
    return (
      getEventImageThumbnail(bannerImagePath ?? "", defaultImage ?? "") ?? ""
    );
  }

  return firstItem.thumbnail ?? "";
};

type ConvertOrderToCardProps = (
  order: LegacyPortalPurchaseHistoryOrder
) => ConvertedSettlement;

export const convertOrderToCardProps: ConvertOrderToCardProps = (order) => ({
  hasGoods: order.items.some(
    (item) => item.productType === LegacyPortalPurchaseHistoryProductType.GOODS
  ),
  imagePath: getImagePath(order.items[0]),
  // 注文番号をそのまま識別子にする。Shopify注文は注文名（#SD1042）が入っている
  linkTo: toPurchaseHistoryOrderPath(order.orderId),
  orderId: order.displayOrderNumber,
  paymentStatus: toPaymentStatus(order.status),
  paymentType: toPayType(order.payType),
  purchasedAt: order.createdAt === undefined ? 0 : Number(order.createdAt),
  // 一覧は明細の数量合計を出す（Firestore直読み側と同じ。APIのpurchasedCountは詳細で使う値）
  purchasedCount: order.items.reduce((total, item) => total + item.quantity, 0),
});
